import React from 'react'

import ModalLayout from '@/app/component/layout/modal'

import UpdateGroupForm from './form/update-group-form'

type Props = {
  open: boolean
  groupId: number
  onClose: () => void
}

const UpdateGroupDialog: React.FC<Props> = ({ open, groupId, onClose }) => (
  <ModalLayout title="Edit group" isOpen={open} onClose={onClose}>
    <UpdateGroupForm groupId={groupId} onExit={onClose} />
  </ModalLayout>
)

export default UpdateGroupDialog
